export class VehicleAssignKeyRequest {
  constructor(public keyNumber: number) {
  }
}
